import * as React from "react"
import { Link} from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import ExpandableTable from "./expandableTable";
import Carousel from 'react-bootstrap/Carousel';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import podcastImg from "./assets/podcast.png";
import applePodcastImg from "./assets/applePodcasts.svg";
import googlePodcastImg from "./assets/Google_Podcasts.svg";
import spotifyImg from "./assets/Spotify_logo.svg";
import RssFeedIcon from '@mui/icons-material/RssFeed';
import { Typography, CardActionArea, CardHeader } from "@mui/material";
import onlineCultivationImg from "./assets/onlineCultivation.jpg";
import { Button } from '@mui/material';
import Table from 'react-bootstrap/Table';
import { isMobile } from "./mobile";
import {events} from "./upcoming-events";

const practiceTableRows=[{index: 1, title: "1. 我們發願盡快成佛。", content: <video controls width="70%" center><source src="https://bli.blob.core.windows.net/media/vowToRealizeBuddhaWay.mp4" type="video/mp4" /></video> },
{index: 2, title: "2. 我們修行是為了幫助他人，不為幫助自己。", content: <video controls width="70%" center><source src="https://bli.blob.core.windows.net/media/helpOthers.mp4" type="video/mp4" /></video>},
{index: 3, title:"3. 我們修習的主要內容之一是孝道：報答父母師長之恩。", content: <video controls width="70%" ><source src= "https://bli.blob.core.windows.net/media/What is Filiality_ _ Dharma Glimpse.mp4"  type="video/mp4" /></video>},
{index: 4, title: "4. 我們專修大乘淨土行，願今生往生阿彌陀佛的西方極樂世界。", content: <video controls width="70%" center><source src="https://bli.blob.core.windows.net/media/rebirthToPureland.mp4" type="video/mp4" /></video>},
{index: 5, title: "5. 我們禪淨雙修，用禪修訓練技術來提高念佛時的定力。", content: <video controls width="70%" center><source src="https://bli.blob.core.windows.net/media/Replace Bad Thoughts with the Buddha's Name _ Dharma Glimpse.mp4" type="video/mp4" /></video>}];

function getRelevantEvents(events) {
    const now = new Date();
    const thirtyDaysLater = new Date();
    thirtyDaysLater.setDate(thirtyDaysLater.getDate() + 30);

    let filteredEvents = events.filter(event => {
        const start = new Date(event.dateBegin);
        const end = new Date(event.dateEnd);

        return (start <= now && end >= now) || (start > now && start <= thirtyDaysLater);
    });

    // Sort events: ongoing first, then by start date
    filteredEvents.sort((a, b) => {
        const startA = new Date(a.dateBegin);
        const startB = new Date(b.dateBegin);
        const endA = new Date(a.dateEnd);
        const endB = new Date(b.dateEnd);

        const isOngoingA = startA <= now && endA >= now;
        const isOngoingB = startB <= now && endB >= now;

        if (isOngoingA && !isOngoingB) return -1;
        if (!isOngoingA && isOngoingB) return 1;
        return startA - startB;
    });

    return filteredEvents.slice(0, 3);
}

const IndexPage = () => {

  // TODO: fix image width to about 80%? width="80%" do not work.
  let masterIntro=<Stack direction="horizontal" gap={4}>
    <img src="/masterphoto1.png" loading="eager" style={{width: "75%"}} />
    <div>
      <Typography variant="h2"><b>永化法師</b></Typography><br/><Typography variant="body1">永化法師出生於南越，1973年來美國上大學，在明尼蘇達大學獲得數學學士學位，在芝加哥大學獲得MBA學位。<br/><Link to="master">閱讀更多&gt;&gt;</Link><br/></Typography>
    </div>
  </Stack>;

  let foqiIntro=<Stack direction="horizontal" gap={4}>
    <img src="/foqi-thumbnail.png"  loading="lazy"/>
  <div><Typography variant="h2"><b>佛七</b></Typography><br/><Typography variant="body1">《阿彌陀經》中記載：“聞說阿彌陀佛，執持名號，若一日、若二日、若三日、若四日、若五日、若六日、若七日，一心不亂，其人臨命終時，阿彌陀佛，與諸聖眾，現在其前。”<br/>
  念佛一聲 罪滅河沙，我們在為期一周的佛七期間精進念佛修習淨土法門。<br/><br/><Link to="foqi">閱讀更多&gt;&gt;</Link><br/></Typography></div>
  </Stack>

  let chanqiIntro=<Stack direction="horizontal" gap={4}>
    <div>
      <Typography variant="h2"><b>禪七</b></Typography><br/><Typography variant="body1">我們的精進禪七是一個難得的修習傳統禪宗的機會。至誠精進的同修們會體驗到人生的改變，比如改善健康，得到禪定，在菩提道上得到更多的智慧和更接近開悟。 <br/>禪宗在日本和西方國家被稱為Zen。傳統的禪宗要求極嚴，我們建議參與者盡可能地遵循時間表，如有需要可以額外休息。<br/><br/><Link to="chanqi">閱讀更多&gt;&gt;</Link><br/></Typography>
    </div>
    <img src="/chanqi-thumbnail.png"  loading="lazy" />
  </Stack>;

if((typeof window !== 'undefined') && window.screen.width< 667) {
    masterIntro=<div>
      <img src="/masterphoto1.png" loading="eager" />
  <div><Typography variant="h2" style={{textAlign:"center"}}><b>永化法師</b></Typography><br/><Typography variant="body1">永化法師出生於南越，1973年來美國上大學，在明尼蘇達大學獲得數學學士學位，在芝加哥大學獲得MBA學位。<br/><Link to="master">閱讀更多&gt;&gt;</Link><br/></Typography></div>
    </div>;

foqiIntro=<div>
  <img src="/foqi-thumbnail.png"   loading="lazy" />
<div><Typography variant="h2" style={{textAlign:"center"}}><b>佛七</b></Typography><br/><Typography variant="body1">《阿彌陀經》中記載：“聞說阿彌陀佛，執持名號，若一日、若二日、若三日、若四日、若五日、若六日、若七日，一心不亂，其人臨命終時，阿彌陀佛，與諸聖眾，現在其前。”<br/>
念佛一聲 罪滅河沙，我們在為期一周的佛七期間精進念佛修習淨土法門。<br/><br/><Link to="foqi">閱讀更多&gt;&gt;</Link><br/></Typography></div></div>

chanqiIntro=<div>
  <img src="/chanqi-thumbnail.png"   loading="lazy" />
<div><Typography variant="h2" style={{textAlign:"center"}}><b>禪七</b></Typography><br/><Typography variant="body1">我們的精進禪七是一個難得的修習傳統禪宗的機會。至誠精進的同修們會體驗到人生的改變，比如改善健康，得到禪定，在菩提道上得到更多的智慧和更接近開悟。 <br/>
  禪宗在日本和西方國家被稱為Zen。傳統的禪宗要求極嚴，我們建議參與者盡可能地遵循時間表，如有需要可以額外休息。<br/><br/><Link to="chanqi">閱讀更多&gt;&gt;</Link><br/></Typography></div>
  </div>;
  }

const upcomingEvents=getRelevantEvents(events).map(e=><tr>
  {isMobile? <></> : <td/>}
  <td colSpan={3}>
    <img src={e.thumbnail}  />
    <br/>
    <Typography variant="h2" style={{textAlign:"center"}}><b>{e.title}</b></Typography>
    <br/>
    {e.html}
    <br/>
  </td>
  {isMobile? <></> : <td/>}
</tr>
);

  return (
  <>
  <NavigationBar/>
  <Layout>
    <div style={{textAlign: "center"}}>
    <img src="/bli-logo.png" loading="lazy" width={150} />
      <Typography variant="h1">
      <strong>美國大乘佛教</strong>
      </Typography>
      <Typography variant="h6">美國大乘佛教以中國大乘佛教為根本，由永化法師為美國文化和美國的感受方式而重新詮釋</Typography>
      </div>
      <h2><br/></h2>
      <Carousel controls={true} indicators={false} pause={false} interval={10000} style={ isMobile? {} : {overflow: "hidden", height: "500px"}}>
        {/* use a higher quality for these bigger images. */}
        <Carousel.Item>
          <img src="/carousel1.png"  loading="lazy" />
        </Carousel.Item>
        <Carousel.Item>
          <img src="/carousel2.png"  loading="lazy" />
        </Carousel.Item>
        <Carousel.Item>
          <img src="/carousel3.png" loading="lazy" />
        </Carousel.Item>
        <Carousel.Item>
          <img src="/carousel4.png" loading="lazy" />
        </Carousel.Item>
        <Carousel.Item>
          <img src="/carousel5.png"  loading="lazy" />
        </Carousel.Item>
      </Carousel>
      <br/>

<img src="/header-upcevents.png" loading="eager"  />
<Table style={{ tableLayout: "fixed" }}>
<tbody>
{upcomingEvents}

</tbody></Table>
<br/>
<Link to="/location" >
  <img src="/viewlocation.png" loading="lazy"  />
</Link>

<div>
<img src="/ourteacher.png" loading="eager"  />
{masterIntro}
<Link to="/ceremonies">
  <img src="/recording-of-ceremonies.png" loading="lazy"  />
</Link>
</div>
<div>
<img src="/our-practices.png" loading="lazy"  />
<Typography variant="body1"><b>我們是秉持如下信念的佛教修行者團體：</b></Typography><br/>
<ExpandableTable rows={practiceTableRows}/>
<a href="https://www.youtube.com/c/MasterYongHua/live" target="_blank">
  <img src="/livestream-banner.png" loading="lazy"  />
</a>
</div>
<div>
<img src="/specialretreats.png" loading="lazy"  />
{foqiIntro}
{chanqiIntro}
</div>
<br/>
<a href="https://chanpureland.us5.list-manage.com/subscribe?u=b627a6275252f023b6958021c&id=d354912c7e">
  <img src="/mailing-list.png" loading="lazy"  />
</a>
<br/>
<br/>
<Stack direction="horizontal" gap={4}>
  <a href="https://workflowy.com/s/dharma/2JXvP7OsgXaxvczd">
    <img src="/database.png" loading="lazy"  />
  </a>
  <a href="https://www.chanpureland.org/27861358212637621002" target="_blank">
    <img src="/past-blog-posts.png" loading="lazy"  />
  </a>
  <a href="https://www.chanpureland.org/download-audio--slides.html" target="_blank">
    <img src="/download-resources.png" loading="lazy"  />
  </a>
</Stack>
  </Layout>
  </>
)
  }


export default IndexPage
